import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export function createStore({ flow, name, persist: shouldPersist = true }) {
  const storeConfig = (set, _, store) => ({
    flow,
    step: 0,
    stepsCount: 0,
    virtualStep: 0,
    virtualStepsCount: 0,
    flowParams: {},
    setFlow: (flow) => {
      set({ flow });
    },
    setStep: (step) => {
      set({ step });
    },
    setStepsCount: (stepsCount) => {
      set({ stepsCount });
    },
    setVirtualStep: (virtualStep) => {
      set({ virtualStep });
    },
    setVirtualStepsCount: (virtualStepsCount) => {
      set({ virtualStepsCount });
    },
    prevStep: () => {
      set((state) => ({ step: state.step - 1 }));
    },
    nextStep: () => {
      set((state) => ({ step: state.step + 1 }));
    },
    setFlowParams: (flowParams) => {
      set({ flowParams });
    },
    reset: () => {
      set(store.getInitialState());
    },
  });

  if (shouldPersist) {
    return create(
      persist(storeConfig, {
        name,
      })
    );
  } else {
    return create(storeConfig);
  }
}
